import { DialogContent, DialogClose } from '@/components/dialog';
import Link from 'next/link';

export default function LeavingDialog() {
  return (
    <DialogContent className="max-w-[557px] p-[20px]">
      <p className="mb-[50px] mt-[80px] text-center text-[20px] font-semibold leading-[32px] text-[#231717]">
        入力内容は保持されません。
        <br />
        画面を離れますか？
      </p>
      <div className="mb-[40px] flex items-center justify-center gap-[40px]">
        <DialogClose className="hover-animation h-[48px] w-[144px] rounded-[28px] border-2 border-solid border-primary font-semibold text-primary-500">
          キャンセル
        </DialogClose>
        <Link
          href="/top"
          className="hover-animation flex h-[48px] w-[144px] items-center justify-center rounded-[28px] bg-primary-500 font-semibold text-white"
        >
          OK
        </Link>
      </div>
    </DialogContent>
  );
}
